// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"944":"27a00d2c","951":"62273f12"}[chunkId] + ".chunk.css";
};